import { getPortalApiUrl, getPostmanMockUrl, getFeatureFlags } from "./envvars";
import fakeToken from "../fixtures/fake-token";
const { mockTest } = getFeatureFlags();

const apiURL = mockTest ? getPostmanMockUrl() : getPortalApiUrl();

const postmanKey = process.env.REACT_APP_TEST_PMAK;

async function client(
  endpoint,
  { data, token, headers: customHeaders, ...customConfig } = {}
) {
  const mockConfig = {
    method: data ? "POST" : "GET",
    body: data ? data : undefined,
    headers: {
      Authorization: `Bearer ${fakeToken}`,
      "x-api-key": postmanKey,
      ...customHeaders,
    },
    ...customConfig,
  };
  const prodConfig = {
    method: data ? "POST" : "GET",
    body: data ? data : undefined,
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      ...customHeaders,
    },
    ...customConfig,
  };
  //console.log("endpoint", endpoint);

  //console.log("token in client", token ? "with token" : null);

  const config = mockTest ? mockConfig : prodConfig;

  return window
    .fetch(`${apiURL}/${endpoint}`, config)
    .then(async (response) => {
      if (response.status === 204) {
        // success with no data returned
        return true;
      }
      // not logged in
      // if (response.status === 401) {
      //   // TODO
      //   await auth.logout();
      //   // refresh the page for them
      //   window.location.assign(window.location);
      //   return Promise.reject({ message: "Please re-authenticate." });
      // }

      if (response.status === 401 || response.status === 403) {
        //const errorData = await response.json();
        //const errorMessage = errorData?.status?.extra;
        //console.log("4xx error in client", errorData);
        //return "Please log in to access this page";
        //throw new Error("Please log in to access this page.");
        return Promise.reject({
          message: "logout",
          httpCode: response.status,
        });
      }
      if (
        response.status === 500 ||
        response.status === 502 ||
        response.status === 504
      ) {
        //console.log("5xx error in client");
        return Promise.reject({
          message: "An error has occurred. Please try again later.",
          httpCode: response.status,
        });
      }
      // validation errors or custom portalapi error
      if (response.status === 422 || response.status === 400) {
        const errorData = await response.json();
        //console.log("422 error in client", errorData);
        return errorData;
      }

      const data = await response.json();
      if (response.ok) {
        //console.log("accessed ", endpoint);
        // console.log("data in client response ok", data);
        return data;
      } else {
        //console.log("data in response not ok", data);
        return Promise.reject(data);
      }
    });
}

export { client };

/**
5xx ERROR CODES:
500 internal server error
502 bad gateway - proxy didn't get response from origin server
503 service unavailable - origin server unavailable (maintenance, traffic, etc)
504 gateway timeout - similar to 502

4xx ERROR CODES:
400 bad request
401 not logged in
404 not found
403 forbidden 
422 unprocessable entry returned when server validation failed
let customHeaders = {
 "x-mock-response-code": "[code]",
};
*/
